import * as AlertDialog from '@radix-ui/react-alert-dialog'
import { AlertTriangle, Trash2 } from 'lucide-react'

import { Button } from '../ui/Button'
import { Spinner } from '../ui/Spinner'

import type { Company } from '../../types/company'

interface DeleteCompanyDialogProps {
  company: Company | null
  open: boolean
  deleting: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: (company: Company) => Promise<void>
}

export function DeleteCompanyDialog({
  company,
  open,
  deleting,
  onOpenChange,
  onConfirm,
}: DeleteCompanyDialogProps) {
  if (!company) return null

  return (
    <AlertDialog.Root open={open} onOpenChange={(nextOpen) => !deleting && onOpenChange(nextOpen)}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 z-40 bg-ink/55 backdrop-blur-sm" />
        <AlertDialog.Content className="fixed left-1/2 top-1/2 z-50 w-[min(30rem,calc(100%-2rem))] -translate-x-1/2 -translate-y-1/2 rounded-3xl bg-paper p-6 shadow-2xl focus:outline-none sm:p-7">
          <span className="grid h-11 w-11 place-items-center rounded-2xl bg-red-100 text-red-700">
            <AlertTriangle aria-hidden="true" className="h-5 w-5" />
          </span>
          <AlertDialog.Title className="mt-5 font-display text-2xl font-bold tracking-tight">
            Eliminar empresa
          </AlertDialog.Title>
          <AlertDialog.Description className="mt-2 text-sm leading-6 text-ink/65">
            Vas a eliminar <strong className="font-bold text-ink">{company.name}</strong>, todos sus
            correos y su imagen. Esta acción no se puede deshacer.
          </AlertDialog.Description>
          <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
            <AlertDialog.Cancel asChild>
              <Button variant="secondary" disabled={deleting}>
                Cancelar
              </Button>
            </AlertDialog.Cancel>
            <Button variant="danger" disabled={deleting} onClick={() => void onConfirm(company)}>
              {deleting ? <Spinner /> : <Trash2 aria-hidden="true" className="h-4 w-4" />}
              {deleting ? 'Eliminando…' : 'Eliminar definitivamente'}
            </Button>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}
